// @flow
import * as PublicAccountPagesConstants from "../../Constants/PublicAccountPages/publicAccountPagesConstants";

export function loginFormElementValueChange(formElement: string, value: string): Object {
  return {
    type: PublicAccountPagesConstants.LOGIN_FORM_ELEMENT_VALUE_CHANGE,
    payload: { formElement, value }
  };
}

export function loginFormSubmit(formElements: Object): Object {
  return {
    type: PublicAccountPagesConstants.LOGIN_FORM_SUBMIT_REQUEST,
    payload: { formElements }
  }
}

export function loginFormErrorRelease() {
  return {
    type: PublicAccountPagesConstants.LOGIN_FORM_ERROR_RELEASE
  }
}


// WEBPACK FOOTER //
// ./src/Actions/PublicAccountPages/login.js